import React from 'react'
import PropTypes from 'prop-types'
import { TrashIcon, RedoIcon, EyeIcon, PlusImageIcon, PenToolIcon, MediaIcon, UploadIcon } from 'images'

const getMenuIcon = (key) => {
  switch (key) {
    case 'replace':
      return <RedoIcon width={16} height={16} />
    case 'preview':
      return <EyeIcon width={16} height={16} />
    case 'addVariants':
      return <PlusImageIcon width={16} height={16} />
    case 'rename':
      return <PenToolIcon width={16} height={16} />
    case 'library':
      return <MediaIcon width={16} height={16} />
    case 'device':
      return <UploadIcon width={16} height={16} />
    case 'remove':
    case 'delete':
      return <TrashIcon width={16} height={16} />
    default:
      return null
  }
}

const ActionMenu = ({ actionMenuItems = [], setIsMenuOpen }) => {
  const handleItemClick = (onClick) => (event) => {
    event.stopPropagation()
    onClick?.()
    setIsMenuOpen(false)
  }

  return (
    <div className="action-menu" role="menu">
      {actionMenuItems.map((item) => (
        <button
          key={item.key}
          className="action-menu__item"
          type="button"
          role="menuitem"
          onClick={handleItemClick(item.onClick)}
        >
          {getMenuIcon(item.key)}

          <span className="text">{item.label}</span>
        </button>
      ))}
    </div>
  )
}

ActionMenu.propTypes = {
  actionMenuItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })),
  setIsMenuOpen: PropTypes.func.isRequired,
}

export default ActionMenu
